@if (template() || content()) {
  <div class="hx-popover" [class.pointer]="variant() === 'pointer'" [attr.data-position]="position()">
    @if (template()) {
      <ng-container [ngTemplateOutlet]="template()"></ng-container>
    } @else {
      <ng-content></ng-content>
      @if (content()) {
        <span>{{ content() }}</span>
      }
    }

    @if (variant() === 'pointer') {
      <span class="arrow"></span>
    }
  </div>
}
